<div mat-dialog-title class="dialog-title" style="margin: 0">
  <span mat-dialog-title>Contract renewal</span>
  <button mat-icon-button (click)="onCloseRenewal()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-horizontal-stepper
  #stepper
  *ngIf="contract"
  [selectedIndex]="0"
  [linear]="true"
  [@.disabled]="true"
  (selectionChange)="onStepChange($event)"
>
  <mat-step *ngIf="questions?.current && questions?.new" [stepControl]="newContractForm.form">
    <ng-template matStepLabel>Contract Data</ng-template>
    <mat-divider></mat-divider>
    <div class="wrapper-step-1">
      <div class="step-1-wrapper-contract-data">
        <div class="wrapper-title">
          <h4 mat-dialog-title>Contract Data</h4>
        </div>
        <div class="wrapper-data">
          <app-dynamic-form #currentContractForm class="form" [showButtons]="false" [questions]="questions.current">
          </app-dynamic-form>
          <app-dynamic-form
            #newContractForm
            class="form"
            [showButtons]="false"
            [questions]="questions.new"
            (hasChanged)="onNewContractFormChange($event)"
          >
          </app-dynamic-form>
        </div>
      </div>
    </div>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>Select Existing Assets</ng-template>
    <mat-divider></mat-divider>
    <mat-dialog-content class="mat-typography"> </mat-dialog-content>
    <app-data-table
      #existingAssetsTable
      *ngIf="tablesConfigs?.existingAssets"
      [config]="tablesConfigs?.existingAssets"
      (getData)="getAllowedAssetsToRenew($event)"
      (updateData)="updateAsset($event, existingAssetsTable)"
    ></app-data-table>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>Select New Assets</ng-template>
    <mat-divider></mat-divider>
    <mat-dialog-content class="mat-typography"> </mat-dialog-content>
    <app-data-table
      #companyAssetsTable
      *ngIf="tablesConfigs?.companyAssets"
      [config]="tablesConfigs?.companyAssets"
      (getData)="getAllowedAssetsToAdd($event)"
      (updateData)="updateAsset($event, companyAssetsTable)"
    ></app-data-table>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>Pricing Review</ng-template>
    <mat-divider></mat-divider>
    <mat-dialog-content class="mat-typography"> </mat-dialog-content>
    <app-data-table
      #reviewAssetsTable
      *ngIf="tablesConfigs?.reviewAssets"
      [config]="tablesConfigs?.reviewAssets"
      (getData)="getAssetsToReview($event)"
      (updateData)="updateAsset($event)"
    >
      <ng-template #customToolBar let-context>
        <!-- Price Discount Input -->
        <mat-form-field #discountField class="discount-field" appearance="fill">
          <mat-label>Discount</mat-label>
          <button mat-icon-button matPrefix (click)="onDiscountTypeChange()">
            <mat-icon>{{ discountType === "%" ? "percent" : "attach_money" }}</mat-icon>
          </button>
          <input
            #discountInput
            matInput
            type="discount"
            appOnlyNumbers
            [allowDecimal]="true"
            [maxLength]="10"
            [formControl]="discount"
          />
          <button
            mat-icon-button
            matSuffix
            (click)="onApplyDiscount(discountInput.value)"
            [disabled]="discount.invalid"
          >
            <mat-icon>check</mat-icon>
          </button>
        </mat-form-field>
      </ng-template>
    </app-data-table>
  </mat-step>
  <mat-step [editable]="false">
    <ng-template matStepLabel>Confirmation</ng-template>
    <mat-divider></mat-divider>
    <div *ngIf="stepper.selectedIndex | applyFunctionOrValue: isLastStep:stepper" class="wrapper-step-4">
      <div class="wrapper-title">
        <h4 mat-dialog-title>Contract Summary</h4>
      </div>
      <div class="wrapper-data">
        <app-dynamic-form
          #summaryContractForm
          class="summary-form"
          [showButtons]="false"
          [questions]="questions.summary"
        >
        </app-dynamic-form>
      </div>
    </div>
  </mat-step>
</mat-horizontal-stepper>
<div class="modal-footer" *ngIf="contract && stepper">
  <span
    class="assets-count"
    *ngIf="stepper.selectedIndex | applyFunctionOrValue: getAssetsListMessage:stepper; let message"
    >{{ message }}</span
  >
  <button
    *ngIf="stepper.selectedIndex | applyFunctionOrValue: hasPreviousStep:stepper"
    mat-button
    color="warn"
    [disabled]="loading"
    (click)="onResetRenewal(stepper)"
  >
    Reset
  </button>
  <button
    *ngIf="stepper.selectedIndex | applyFunctionOrValue: hasPreviousStep:stepper"
    mat-button
    [disabled]="loading"
    (click)="goPreviousStep(stepper)"
  >
    Back
  </button>
  <button
    *ngIf="stepper.selectedIndex | applyFunctionOrValue: hasNextStep:stepper"
    mat-raised-button
    color="accent"
    (click)="goNextStep(stepper)"
  >
    Next
  </button>
  <button
    *ngIf="stepper.selectedIndex | applyFunctionOrValue: isLastStep:stepper"
    mat-raised-button
    color="accent"
    [disabled]="loading"
    (click)="onSubmitRenewal()"
  >
    Submit
  </button>
</div>
